import { Injectable, Injector } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpErrorResponse,
  HttpEvent,
  HttpResponseBase,
  HttpResponse,
} from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { mergeMap, catchError, every } from 'rxjs/operators';
import { ModalService, ToastService } from 'ng-zorro-antd-mobile';
import { environment } from '../../../environments/environment';
import { ZoToastService } from '../service/zo-toast.service';

const CODEMESSAGE = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网关错误。',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网关超时。',
};

/**
 * 默认HTTP拦截器，其注册细节见 `app.module.ts`
 */
@Injectable()
export class DefaultInterceptor implements HttpInterceptor {

  constructor(private injector: Injector, private _modal: ModalService, private router: Router,
              private activateRoute: ActivatedRoute, private toastService: ZoToastService) {}

  private goTo(url: string) {
    setTimeout(() => this.router.navigateByUrl(url));
  }

  private checkStatus(ev: HttpResponseBase) {
    if ((ev.status >= 200 && ev.status < 300) || ev.status === 401) {
      return;
    }
    // this.showTips(CODEMESSAGE[ev.status]);
    // this.showTips('服务器请求错误，请稍后重试');
  }

  private handleData(ev: HttpResponseBase): Observable<any> {
    this.toastService.hideLoading();
    this.checkStatus(ev);
    // 业务处理：一些通用操作
    switch (ev.status) {
      case 200:
        if (ev instanceof HttpResponse) {
            const body: any = ev.body;
            if (body && body.return_code !== 'SUCCESS') {
                this.showTips(body.return_code_desc);
                // 继续抛出错误中断后续所有 Pipe、subscribe 操作，因此：
                // this.http.get('/').subscribe() 并不会触发
                return throwError(ev);
            }
        }
        break;
      case 401:
        this.showTips(`未登录或登录已过期，请重新登录。`);
        // 清空 token 信息
        // (this.injector.get(DA_SERVICE_TOKEN) as ITokenService).clear();
        // this.goTo('/passport/login');
        break;
      case 400:
      case 403:
      case 404:
      case 500:
        // this.goTo(`/exception/${ev.status}`);
        this.showTips(CODEMESSAGE[ev.status]);
        return throwError(ev);
        break;
      default:
        if (ev instanceof HttpErrorResponse) {
          console.warn('未可知错误，大部分是由于后端不支持CORS或无效配置引起', ev);
          return throwError(ev);
        }
        break;
    }
    return of(ev);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // 统一加上服务端前缀
    let url = req.url;
    if (!url.startsWith('https://') && !url.startsWith('http://')) {

      const startIndex = location.pathname.indexOf('merchants/');
      const endIndex = location.pathname.indexOf('/', startIndex + 10);
      const merchantId = location.pathname.substring(startIndex + 10, endIndex);
      url = environment.server_url.replace('{merchantId}', merchantId) + url;
    }

    const newReq = req.clone({ url });
    this.toastService.showLoading();
    return next.handle(newReq).pipe(
      mergeMap((event: any) => {
        // 允许统一对请求错误处理
        if (event instanceof HttpResponseBase) {
          return this.handleData(event);
        }
        // 若一切都正常，则后续操作
        return of(event);
      }),
      catchError((err: HttpErrorResponse) => {
        return this.handleData(err);
      }),
    );
  }

  showTips(msg: string) {
    this._modal.alert('提示', msg, [
      { text: '确定', onPress: () => this._modal.close() }
    ]);
  }
}
